<template>
  <Modal
    size="lg"
    :loading="this.showLoader"
    loadingText="Sparar"
    :confirmText="state == STATES.ALLOW_CREATION ? 'Skapa' : null"
    v-on:confirm="createSubscription()"
    :cancelText="state !== STATES.ALLOW_CREATION ? 'OK' : 'Avbryt'"
    v-on:cancel="state !== STATES.ALLOW_CREATION ? $emit('close') : $emit('close')"
  >
    <div v-if="state == STATES.ALLOW_CREATION">
      <h3 class="text-t6 mb-4 text-center">Du är på väg att lägga till en ny e-postbevakning.</h3>
      <p class="text-b2 text-center">
        Det innebär att du får ett e-postmeddelande när din bevakning matchar ett ledigt
        hyresobjekt.
      </p>
    </div>
    <div v-else-if="state == STATES.DENY_CREATION">
      <h3 class="text-t6 mb-4 text-center">Du kan maximalt ha tre aktiva bevakningar åt gången.</h3>
      <p class="text-b2 text-center">
        Gå in på Mina sidor och ta bort bevakningar innan du kan lägga till nya.
      </p>
    </div>
    <div v-else-if="state == STATES.CREATED">
      <h3 class="text-t6 mb-4 text-center">Din bevakning är skapad</h3>
      <p class="text-b2 text-center">
        När din bevakning matchar ett ledigt hyresobjekt meddelas du via e-post.
      </p>
    </div>
    <div v-else-if="state == STATES.FAILED_TO_CREATE">
      <p class="text-b2 text-center">Det gick inte att skapa bevakningen</p>
    </div>
  </Modal>
</template>

<script>
import dayjs from 'dayjs';
import { dataLayerPush } from '@/helpers/datalayer';
import Modal from '@/components/ui/modal';
import Button from '@/components/ui/button';
import Loader from '@/components/ui/loader';

const STATES = {
  ALLOW_CREATION: 1,
  DENY_CREATION: 2,
  CREATED: 3,
  FAILED_TO_CREATE: 4,
};

export default {
  name: 'ConfirmSubscription',
  components: { Modal, Loader, Button },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  emits: ['done', 'close'],
  data() {
    return {
      showLoader: true,
      state: null,
      STATES,
    };
  },
  methods: {
    createSubscription() {
      this.showLoader = true;
      // "parking" + "s"
      const type = !this.type.match(/s$/) ? this.type + 's' : this.type;
      let _filters = {};

      Object.keys(this.filters).forEach((key) => {
        if (key == 'rentalObjectTypes') {
          let arr = [];
          Object.keys(this.filters[key]).forEach((k) => {
            if (this.filters[key][k] == true) arr.push(k);
          });

          _filters[key] = arr;
        } else if (this.filters[key] && key != 'rentalObjectTypes')
          _filters[key] = this.filters[key];
      });
      return (
        this.$store
          .dispatch('createSubscription', {
            subscription: {
              ..._filters,
              administrativeUnitAreas: this.filters.administrativeUnitAreas,
              administrativeUnitDistricts: null,
              administrativeUnitTownDistricts: null,
              minRent: null,
            },

            /**
             * Är det en bevakning på lägenheter, parkering eller förråd.
             */
            type,
          })
          .then(() => {
            let texttype = '';
            if (type == 'apartments') texttype = 'lagenhet';
            else if (type == 'parkings') texttype = 'fordonsplats';
            else if (type == 'studentapartments') texttype = 'studentbostad';
            else texttype = 'forrad';

            dataLayerPush({
              event: 'createSurveillance',
              SurveillanceType: texttype,
            });

            this.state = STATES.CREATED;
          })
          .catch(() => {
            this.state = STATES.FAILED_TO_CREATE;
          })

          /**
           * Göm loadern, oavsett om requesten gick bra eller dåligt
           */
          .finally(() => {
            this.showLoader = false;
          })
      );
    },
  },

  created() {
    return this.$store.cache
      .dispatch('fetchSubscriptions')
      .then(() => {
        const activeSubs = this.$store.getters.subscriptions.filter((sub) => {
          return sub.enabled && dayjs(sub.waitingListPeriodTo).diff(new Date(), 'days') > 0;
        });

        this.state = activeSubs.length < 3 ? STATES.ALLOW_CREATION : STATES.DENY_CREATION;
      })
      .finally(() => {
        this.showLoader = false;
      });
  },
};
</script>
